import BackRouter from "@/components/customs/BackRouter";
import Logo from "@/components/customs/Logo";
import { ArrowLeft } from "iconsax-react";
import Image from "next/image";

import LoginTabs from "./LoginTabs";

import { SupportedLanguage } from "@/lib/shared";
import lang from "./lang.json";
import { cn } from "@/lib/utils";

type LoginProps = {
  locale: SupportedLanguage;
  tab: string;
  redirect?: string;
  withImage?: boolean;
};

export default function Login({
  locale,
  tab,
  redirect,
  withImage,
}: LoginProps) {
  return (
    <div className="flex relative min-h-screen">
      {/* Left side - Login form */}
      <div className={cn("w-full", { "md:w-1/2": withImage })}>
        <div
          className={cn(
            "flex flex-col gap-y-8 max-w-md mx-auto w-full min-h-screen",
            withImage ? "p-10" : "p-4 "
          )}
        >
          {withImage && (
            <div className="flex gap-x-8 items-center">
              <BackRouter>
                <span className="text-gray-950 cursor-pointer">
                  <ArrowLeft
                    size="32"
                    variant="Outline"
                    className="fill-current"
                  />
                </span>
              </BackRouter>
              <Logo />
            </div>
          )}

          <span className="flex flex-col gap-y-2">
            <h1 className="text-3xl font-bold">{lang["login"][locale]}</h1>
            <p className="text-gray-600">{lang["welcome-back"][locale]}</p>
          </span>

          <LoginTabs
            initialTab={tab}
            locale={locale}
            redirect={redirect}
          />
        </div>
      </div>

      {/* Right side - Carousel */}
      <div
        className={cn(
          "hidden lg:flex w-1/2 bg-primary-darken items-center justify-center p-10 h-screen fixed top-0 right-0 rtl:right-auto rtl:left-0",
          { hidden: !withImage, "md:flex": withImage }
        )}
      >
        <div className="absolute inset-0">
          <Image
            src="/images/illustration-users-login.png"
            alt="Login"
            fill
            className="object-cover"
            sizes="(min-width: 768px) 50vw, 100vw"
          />
        </div>
        <div className="max-w-lg text-center w-full h-full flex flex-col justify-end pb-20 items-center relative z-10">
          <div className="mb-10"></div>
          <h2 className="text-3xl font-bold text-white mb-4">
            {lang["login-text"][locale]}
          </h2>
          <p className="text-white text-opacity-90">
            {lang["login-text-description"][locale]}
          </p>
        </div>
      </div>
    </div>
  );
}
